var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-class":_vm.$style.enter,"enter-active-class":_vm.$style.enterActive,"leave-to-class":_vm.$style.leaveTo,"leave-active-class":_vm.$style.leaveActive},on:{"after-leave":_vm.destroyElement}},[(_vm.visible)?_c('div',{class:[
      _vm.$style.toast,
      _vm.$style[_vm.type],
      ( _obj = {}, _obj[_vm.$style.bottom] = _vm.bottom, _obj[_vm.$style.middle] = _vm.middle, _obj[_vm.$style.middleAnimate] = _vm.middleAnimate, _obj )
    ]},[_c('div',{ref:"content",class:_vm.$style.text,style:({textAlign: _vm.textAlign,whiteSpace: _vm.whiteSpace})},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }